import { getColor } from 'common/constants/_colors';
import styled from 'styled-components';

export const StyledPartialPeriod = styled.div`
  margin-left: auto;
`;

export const StyledGraph = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 3rem;

  & > header {
    height: 10%;
    color: ${getColor('shuttleGray')};
    text-align: left;
    position: relative;
    bottom: 1rem;
    display: flex;
  }
  & > main {
    height: 90%;
  }
`;
